(function ($) {
    
    function initCaseStudySlider() {
        $( '.js-case-study-slider' ).each( function() {
            $( this ).slick( {
                infinite: true,
                fade: true,
                slidesToShow: 1,
                arrows: true,
                slidesToScroll: 1,
                prevArrow: $(this).parents('.case-study-section').find('.case-study-arrows-prev'),
                nextArrow: $(this).parents('.case-study-section').find('.case-study-arrows-next')
            });
        });
    }
    
//    var counter = function($this) {
//        var maxNum = Math.abs(parseInt($this.text()));
//        var i = 0;
//        var repeat = maxNum / 50;
//
//        setInterval(function() {
//
//            $this.text(parseInt(i += repeat));
//
//            if (i > maxNum) {
//                $this.text(parseInt(maxNum));
//                return;
//            }
//
//        }, 40);
//    }
    
    function counter(){
        $('.stat-number').each(function() {
            var $this = $(this),
              countTo = $this.attr('data-count');

            $({ countNum: $this.text()}).animate({
                countNum: countTo
            },
            {

                duration: 1000,
                easing:'linear',
                step: function() {
                    $this.text(Math.floor(this.countNum));
                },
                complete: function() {
                    $this.text(this.countNum);
                }
            });
        });
    }

    /* Document Ready */
	$(document).ready(function() {
//        initCaseStudySlider();
        
        document.addEventListener('aos:in:stat-counter', ({ detail }) => {
            counter();
        });
	});

})(jQuery);